const __WEBPACK_NAMESPACE_OBJECT__ = RedNaoPDFImporter.default('PDFImporter/Manager/PDFManager/DocumentManager.Options');